module.exports = __webpack_public_path__ + "media/images/icons/cloud-3e6ce1a82435183b6ca41368596b51e0.svg";